import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { newDate } from "helpers/dateTools";
import { dateValidator } from "helpers/dateValidator";
import { useSearch } from "hooks/useSearch";
import { apiToken } from "redux/actions/supervision/supervisedActions";
import {
  setReportSupervisionFilters,
  getReportSupervisionAction
} from "redux/actions/Reports/reportSupervision/reportSupervisionActions";

export const ReportSupervisionView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { token } = useSelector(({ supervised }) => supervised);
  const { startDate, endDate, station } = useSelector(({ reportSupervision }) => reportSupervision);

  const handleSubmit = (e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) {
      setSnackbar("Faltan datos requeridos.", "warning");
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportSupervisionAction({ startDate, endDate, station, token, isPdf }));
  };

  useEffect(() => {
    dispatch(apiToken());
  }, []);

  return (
    <>
      <GlobalBox title="Reporte de Supervisión" icon={<AssessmentIcon />}>
        {isLoadingComp?.loadingReportSupervision ? <LoadingComponent /> :
          <TableInputs
            reducer="reportSupervision"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportSupervisionFilters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
        }
      </GlobalBox>
    </>
  );
};
